import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI, { size: 'medium' })
Vue.config.productionTip = false

// 全局兜底：拦截未捕获的异常，防止开发环境全屏红色错误覆盖
Vue.config.errorHandler = function (err, vm, info) {
  console.error('[Vue error]', err, info)
}

// 拦截未捕获的 Promise rejection（已处理过的业务错误不再冒泡到全屏）
window.addEventListener('unhandledrejection', event => {
  if (event.reason && event.reason.handled) {
    event.preventDefault()
    return
  }
  console.error('[unhandledrejection]', event.reason)
})

window.addEventListener('error', event => {
  console.error('[global error]', event.error || event.message)
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
